import React, { Component } from "react";
import PropTypes from "prop-types";
import { CSSTransitionGroup } from 'react-transition-group';

class SMSTemplatesCategoryForm extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      name: this.props.name,
      errors: {}
    };
  }

  handleChangeName(e) {
    this.setState({ name: e.target.value });
  }

  validateNotEmpty(fieldName, msg) {
    let value = null;
    value = this.state[fieldName];
    if (value == "" || value == undefined) {
      let newError = {};
      newError[fieldName] = msg;
      this.setState({ errors: Object.assign(this.state.errors, newError) });
    } else {
      let errors = this.state.errors;
      delete errors[fieldName];
      this.setState({ errors: errors });
    }
  }

  save(e) {
    e.preventDefault();
    this.validateNotEmpty("name", "Please enter a name for your category.");
    if (Object.keys(this.state.errors).length == 0) {
      this.props.handleSubmit(this.state);
    }
  }

  render() {
    let { id, name, handleSubmit } = this.props;
    if (!name && id) {
      return (
        <CSSTransitionGroup
          transitionName="spinner"
          transitionAppear={true}
          transitionAppearTimeout={500}
        >
          <div id="content" className="spinner-content">
            <div className="vertical-center">
              <i className="fa fa-refresh fa-4x fa-spin" />
            </div>
          </div>
        </CSSTransitionGroup>
      );
    }
    return (
      <form onSubmit={this.save.bind(this)}>
        <div
          className={`form-group ${this.state.errors.name ? "has-error" : ""}`}
        >
          <label>Category Name</label>
          <input
            type="text"
            className="form-control name_field"
            onChange={this.handleChangeName.bind(this)}
            value={this.state.name}
          />
          <div className="help-block">{this.state.errors.name}</div>
        </div>

        <button type="submit" className="btn btn-primary">
          Save
        </button>
      </form>
    );
  }
}

export default SMSTemplatesCategoryForm;
